<template>
    <div class="thumbnail">
        <img :src="media.thumbnailURL" alt="thumbnail" class="image" />
        <b-row class="userInfo d-flex" align-v="">
            <b-col class="p-0">
                <avatar :name="media.username" :size="20" :photoUrl="media.userPhotoUrl" class="me-1"></avatar>
            </b-col>
            <b-col class="p-0">
                <div class="text-start userName">{{ media.username }}</div>
            </b-col>
        </b-row>
    </div>
</template>
  
<script lang="ts">
import Utils from "@/util/Utils";
import { PropType } from "vue";
import { defineComponent } from "vue";
import PubEventMedia from "@/data/EventMedia";
import Avatar from "@/components/Avatar.vue";

export default defineComponent({
    name: "MediaThumbnail",
    mixins: [Utils],
    components: {
        Avatar,
    },
    props: {
        media: {
            type: Object as PropType<PubEventMedia>,
            required: true,
        },
    },
    data() {
        return {};
    },
    async mounted() {},
    computed: {},
    methods: {},
});
</script>

<style scoped>
.thumbnail {
    position: relative;
    width: 100%; /* Set the width you desire */
    padding-top: 100%; /* Equal to the width for a square aspect ratio */
    /* overflow: hidden; */
}

.image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.userInfo {
    position: absolute;
    bottom: 8px;
    left: 25px;
    display: inline-block;
    align-self: flex-end;
    color: #fff;
    font-size: 10pt;
    text-shadow: rgba(0, 0, 0, 1) 0em 0.1em 0.2em;
}

.userName {
    text-overflow: ellipsis;
    overflow: hidden;
    height: 20px;
    max-width: 60px;
}
</style>
